export default __webpack_public_path__ + "34f5650c9447e4f4e267655cd6e6e884.svg";